<div class="login">
  <div class="side-image"></div>
  <div class="login-form" [ngSwitch]="mode">
    <form
      [formGroup]="loginForm"
      (ngSubmit)="submit($event)"
      *ngSwitchCase="'login'"
    >
      <div class="title">
        <img
          style="width: 150px"
          src="assets/img/everight-logo-small.png"
          alt="logo"
        />
      </div>
      <div class="form">
        <div class="input">
          <div style="font-size: 25px; padding-bottom: 30px">
            Change Password
          </div>
          <mat-form-field class="example-full-width">
            <mat-label>Email</mat-label>
            <input
              formControlName="email"
              type="email"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="loginErrors" class="error">
          <p>{{ loginErrors }}</p>
        </div>
      </div>
      <div class="butto">
        <button *ngIf="!SignLoading" class="btn btn-primary btn-block" color="">
          Send
        </button>
        <button *ngIf="SignLoading" class="btn btn-primary btn-block" color="">
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>
      </div>
      <div (click)="signup()" class="signup" style="cursor: pointer">Back</div>
    </form>

    <form
      [formGroup]="SignUpForm"
      (ngSubmit)="submit($event)"
      *ngSwitchCase="'signup'"
    ></form>
  </div>
</div>
